var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
    active: true,
    callback: _vm.onWaypoint,
    options: _vm.$props.intersectionOptions,
  }),expression:"{\n    active: true,\n    callback: onWaypoint,\n    options: $props.intersectionOptions,\n  }"}],staticClass:"\n    home\n    flex flex-col\n    justify-flex-start\n    lg:justify-center\n    items-flex-start\n    h-screen\n  ",attrs:{"id":"home"}},[_c('HelloWorld')],1)}
var staticRenderFns = []

export { render, staticRenderFns }